﻿import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';

import { fontName, fontSize } from './Font';

var getGraticuleLabel = function () {
    return new Text({
        textAlign: "left",
        textBaseline: "bottom",
        font: `normal 10px ${fontName}`,
        fill: new Fill({
            color: [0, 0, 0, 0.75]
        }),
        stroke: new Stroke({
            color: [255, 255, 255, 0.5],
            width: 1
        })
    })
}

export const latGraticuleLabel = () => {
    return getGraticuleLabel();
}

export const lonGraticuleLabel = () => {
    var style = getGraticuleLabel();
    style.setRotation(Math.PI / 2);
    return style;
}